import script from "./JobDetailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./JobDetailModal.vue?vue&type=script&setup=true&lang=js"

import "./JobDetailModal.vue?vue&type=style&index=0&id=b8ace420&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8ace420"]])

export default __exports__